<template>
    <div class="hotel-list">
      <div class="search-head">
        <div class="search-bar-x">
          <div class="inline-itm">
            <div class="search-cont-box">
              <img src="../../../static/images/icon_location.png" alt="">
              <input
                type="text"
                :placeholder="$t('hotel.Please_enter_your_destination')"
                autocomplete="off"
                id="search_ipt"
                v-model="region_name"
                @focus="defaultCity = true"
                @click="defaultCity = true"
                @input="keywordSearch"
              />
            </div>
          </div>
          <div class="inline-itm double-date-box">
            <!-- 双日历插件 -->
            <double-datepicker :beginDate="params.date_from" :endDate="params.date_to" @select="selectDate"></double-datepicker>
          </div>

          <div class="inline-itm">
            <check-in-room-number
              @on-condition="onGetRoomCount"></check-in-room-number>
          </div>

          <div class="inline-itm search-btn-box">
            <button class="search-btn" @click="replaceUrl()">{{$t('hotel.Search')}}<!-- 搜索 --></button>
          </div>

          <div class="city-dropdown" id="city_dropdown" v-show="defaultCity">
            <div class="city-tab">
              <ul>
                <li class="column-li"
                    :class="{'active': cityShowsId == list.rs_id}"
                    v-for="list in grid_list"
                    :key="list.rs_id"
                    @click="cityShowsId = list.rs_id">{{list.name}}</li>
                <li class="column-li"
                    :class="{'active': cityShowsId == list.rs_id}"
                    v-for="list in column_list"
                    :key="list.rs_id"
                    @click="cityShowsId = list.rs_id">{{list.name}}</li>
              </ul>
            </div>
            <div class="city-list">
              <ul class="grid-box"
                  :class="{'active': cityShowsId == list.rs_id}"
                  v-for="list in grid_list"
                  :key="list.rs_id">
                <li class="citys"
                    v-for="city in list.city_list"
                    @click="selectCity(city)">{{city.name}}</li>
              </ul>
              <ul class="grid-box"
                  :class="{'active': cityShowsId == list.rs_id}"
                  v-for="list in column_list"
                  :key="list.rs_id">
                <li class="citys"
                    v-for="city in list.city_list"
                    @click="selectCity(city)">{{city.name}}</li>
              </ul>
            </div>
          </div>
          <div class="city-dropdown" id="hotel_dropdown" v-show="cityDropdown">
            <div class="result-box">
              <ul>
                <template v-for="(result, idx) of resultList">
                  <li v-if="result.place_type === 'region'" :key="idx" class="result-list region-it" @click="selectCity(result, 'place')">{{result.place_name}} {{result.location}}</li>
                  <li v-if="result.place_type === 'hotel'" :key="idx" class="result-list hotel-it" @click="selectCity(result, 'place')">{{result.place_name}} {{result.location}}</li>
                  <li v-if="result.place_type === 'landmark'" :key="idx" class="result-list landmark-it" @click="selectCity(result, 'place')">{{result.place_name}} {{result.location}}</li>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="list-body warp clearfix">
        <div class="body-item body-left">
          <div class="map-box-x" @click="mapShow = true">
            <img src="../../../static/images/catch_map.png" alt="">
            <p>{{$t('hotel.Show_on_map')}}<!-- 查看地图 --></p>
          </div>
          <!--<div class="filter-head">{{$t('hotel.Filter')}}&lt;!&ndash; 筛选条件 &ndash;&gt;</div>-->
          <div class="filter-box">
            <div class="fliter-item">
              <div class="filter-title">{{$t('hotel.Room_rate2')}}<!-- 费用 --></div>
              <div class="filter-condiction">
                <div class="price-range">
                  <div>
                    <range-slide @left="getLeft" @right="getRight" @min="getMin" @max="getMax"></range-slide>
                  </div>
                  <div class="filter-price"><span class="price-wrapper">{{currency_code}} {{min_price}}</span><span class="price-division">—</span><span class="price-wrapper">{{currency_code}} {{max_price}}</span></div>
                </div>
              </div>
            </div>
            <div class="fliter-item" v-for="(per, i) in filterData.options">
              <div class="filter-title">{{per.name}}</div>
              <div class="filter-condiction">
                <label :for="item.code" class="label" v-for="item in per.items">
                  <input class="h-radio" type="checkbox" :value="item.code" v-model="checkList" :id="item.code" >
                  <!-- <input class="h-radio" type="radio" :value="item.code" v-model="options[i]" :id="item.code" @click="radioToggle($event, item.code, i)"> -->
                  <span class="radio-span"></span>
                  {{item.name}}
                </label>
              </div>
            </div>
            <!--<div class="fliter-item">-->
            <!--<div class="filter-title">{{room_category.name}}</div>-->
            <!--<div class="filter-condiction">-->
            <!--<label :for="item.code" class="label" v-for="item in room_category.items">-->
            <!--<input class="h-radio" type="radio" :value="item.code" v-model="params.room_category" :id="item.code" @click="roomCategoryToggle($event, item.code)">-->
            <!--<span class="radio-span"></span>-->
            <!--{{item.name}}-->
            <!--</label>-->
            <!--</div>-->
            <!--</div>-->
          </div>
        </div>

        <div class="body-item pull-right body-right">
          <div class="list-total">
            {{$t('hotel.Hotels_Found_before')}}<!--搜索到--><span class="many"> {{hotel_total}} </span>{{$t('hotel.Hotels_Found_after')}}<!--家酒店-->
            <!--<a href="javascript:;" class="pull-right check-map" @click="mapShow = true">{{$t('hotel.Show_on_map')}}&lt;!&ndash; 查看地图 &ndash;&gt;</a>-->
          </div>
          <a :href="`${domain}BaigolfClub.php`" v-if="+currentLang === 1 && BCCConfig">
            <div class="bcc-bar">
                <img src="../../../static/images/icon_bcc.png" alt="">
                <span>{{BCCConfig.title}}</span><span class="percent">{{BCCConfig.bcc_discount_percent}}</span><span> >></span>
            </div>
          </a>
          <!--<div class="list-filter" :class="{'price-active': params.sort_by !== 1}">-->
            <!--<span class="sort-text">{{$t('hotel.SEQUENCE')}}&lt;!&ndash; 排序 &ndash;&gt;：</span>-->
            <!--<a href="javascript:;" class="recommend" @click="params.sort_by = 1">{{$t('hotel.RECOMMED')}}&lt;!&ndash; 百高推荐 &ndash;&gt;</a>-->
            <!--<a href="javascript:;"-->
               <!--@click="params.sort_by == 2 ? params.sort_by = 3 : params.sort_by = 2 "-->
               <!--class="price-filter">{{$t('hotel.PRICE')}}&lt;!&ndash; 价格 &ndash;&gt; <span class="icon-box"><b class="filter-icon" :class="{'active': params.sort_by == 2}"></b><b class="filter-icon icon-down"  :class="{'active': params.sort_by == 3}"></b></span></a>-->
          <!--</div>-->

          <div class="list-filter-x">
            <div class="recommend-x" @click="params.sort_by = 1" :class="{'active': params.sort_by == 1}">
              <span>{{$t('hotel.RECOMMED')}}<!-- 百高推荐 --></span><i></i>
            </div>
            <div class="price-filter-x" :class="{'active': params.sort_by == 2 || params.sort_by == 3}" @click="params.sort_by == 2 ? params.sort_by = 3 : params.sort_by = 2 ">
              <span>{{$t('hotel.PRICE')}}<!-- 价格 --></span><i :class="{'asc': params.sort_by == 2, 'desc': params.sort_by == 3}"></i>
            </div>
          </div>

          <!-- 底图 -->
          <div v-show="loading" class="def-list-bg">
            <img src="../../../static/images/default_list_bg.png">
            <div id="courseListSvga" class="g-animate-bg"></div>
          </div>

          <!-- 搜索列表 -->
          <div class="list-box">
            <div class="list-per" v-for="list in hotel_list" :key="list.hotel_id">
              <div class="inline-block per-l" v-bgimg="list.img_url" @click="onlinkToDetail(list)"></div>
              <div class="inline-block per-c">
                <div class="hotel-name" @click="onlinkToDetail(list)">{{list.hotel_name}}
                  <div class="en-name" v-if="currentLangType !== 4 && list.hotel_name !== list.hotel_name_en">{{list.hotel_name_en}}</div>
                </div>
                <!--<recommend-start :startNum="list.score - 0"></recommend-start>-->
                <div class="starts-level" v-if="list.star_rating && list.star_rating > 0">
                  <img src="../../../static/images/start_level.png" alt="" v-for="i in Number(list.star_rating)">
                </div>
                <div class="hotel-address"><img src="../../../static/images/icon_positon@2x.png" alt="">{{list.address}}</div>
                <!--<div class="way-to">{{list.location_introduce}}</div>-->
              </div>
              <div class="inline-block per-r pull-right">
                <div class="hotel-score" v-if="list.score && list.score > 0">
                  <div class="score">{{list.score}}</div>
                  <div class="score-footer-bg"></div>
                </div>
                <div class="hotel-price-package">
                  <div class="bcc-discount" v-if="+currentLang === 1 && list.bcc_discount_amount > 0">B.C.C减CNY {{list.bcc_discount_amount}}起</div>
                  <div class="price-per" v-if="list.min_price.price">
                    <span class="tax-inclusive-price" v-if="list.tax_fee == 0">{{$t('hotel.TAXES_INCL')}} <!-- 含税总价 --></span><span class="currency-code"> {{list.min_price.currency_code}} </span><span class="price">{{ list.min_price.price}}</span><small> {{$t('hotel.ABOVE')}} <!-- 起 --></small>
                  </div>
                  <div class="taxes-dues" v-show="list.tax_fee > 0">{{$t('hotel.Additional_Tax')}}<!-- 另付税/费 --> {{list.min_price.currency_code}} {{list.tax_fee}}</div>
                  <div class="tag" v-if="list.meal_str">{{list.meal_str}}</div>
                </div>

                <!--<div class="hotel-peice" v-show="list.min_price.price"><small>{{list.min_price.currency_code}}</small>{{list.min_price.price}}<small>{{$t('hotel.ABOVE')}}&lt;!&ndash; 起 &ndash;&gt;</small></div>-->
                <!--<div class="taxes-dues" v-show="list.tax_fee > 0">{{$t('hotel.Additional_Tax')}}&lt;!&ndash; 另付税/费 &ndash;&gt; {{list.min_price.currency_code}} {{list.tax_fee}}</div>-->
                <span class="detail-btn" @click="onlinkToDetail(list)">{{$t('hotel.Detail')}}<!-- 查看详情 --></span>
              </div>
            </div>
            <div class="pages" v-show="hotel_total">
              <paginate
                :force-page = "parseInt(params.page)"
                :pageCount="pageCount"
                :prev-text="'上'"
                :next-text="'下'"
                :click-handler="clickCallback"
                next-class="prev page-btn"
                prev-class="next page-btn">
              </paginate>
            </div>
          </div>
        </div>
      </div>
      <div class="mask" v-show="mapShow"></div>
      <div class="map-box warp" v-if="mapShow">
        <baidu-map v-if="mapShow" :map-data="hotel_list" :is-unit-hotel="false" @on-link="onlinkToDetail" ></baidu-map>
        <!-- <map-box :location-data="hotel_list" @on-link="onlinkToDetail"></map-box> -->
        <!--<bing-map :long_lat="hotel_list" @on-link="onlinkToDetail"></bing-map>-->
        <div class="close" @click="mapShow = false"></div>
      </div>

      <!-- 返回顶部 -->
      <scroll-to-top></scroll-to-top>
    </div>
</template>
<script>
  import VuejsDatepicker from 'vuejs-datepicker';
  import {en, ko, ja, zh} from 'vuejs-datepicker/dist/locale';
  import RecommendStart from '@/components/RecommendStart';
  import BingMap from '@/components/BingMap';
  import MapBox from '@/components/MapBox/MapBox';
  import RangeSlide from '@/components/RangeSlide';
  import BgSelect from '@/components/BgSelect';
  import {CheckInNumber} from '@/components';
  import DoubleDatepicker from '@/components/DoubleDatepicker';
  import CheckInRoomNumber from '@/components/CheckInRoomNumber';
  import ScrollToTop from '@/components/ScrollToTop/ScrollToTop';
  import Paginate from 'vuejs-paginate';
  import { formatDateWithStamp, returnType, dateCompare } from '@/utils';
  import {scroll2Top, transformSVGA} from '@/utils';
  import BaiduMap  from '@/components/BaiduMap/BaiduMap';
  /** 定义检测参数变化执行列表更新函数 */
  function watchParams() {
    return {
      handler(n, o){
        this.getHotelList();
      }
    }
  }

  let now = new Date().getTime();
  let secondDay = now + 24*60*60*1000;
  let domain =  process.env.WEB_HOST;

  export default {
    name: 'hotellist',
    data() {
      let query = this.$route.query;

      return {
        en_us: en,
        ko_kr: ko,
        ja_jp: ja,
        zh_cn: zh,
        zh_hk: zh,
        current_lan: zh,
        mapShow: false,
        mapData: [],
        filterData: {},
        // room_category: {},
        hotel_list: [],
        hotel_total: '',
        min_price: 0,
        max_price: 49000,
        fixation_price: 49000,
        region_name: query.region_name || '',
        params: {
          region_id: query.region_id || (query.hotel_id ? '' : 3078),
          hotel_id: query.hotel_id || '',
          place_id: query.place_id || '',
          // date_from: query.date_from ? formatDateWithStamp(query.date_from, true) : formatDateWithStamp(now, true),
          // date_to: query.date_to ? formatDateWithStamp(query.date_to, true) : formatDateWithStamp(secondDay, true),
          date_from: query.date_from || formatDateWithStamp(now, true),
          date_to: query.date_to || formatDateWithStamp(secondDay, true),
          price_from: 0,
          price_to: 49000,
          sort_by: 1,
          // room_category: '',
          options: '',
          page: '1',
          room_count: query.room_count || this.$store.getters.getRooms,
          adults: query.adults || this.$store.getters.getAdults,
          // children: query.children || this.$store.getters.getAges || '',
          children: query.children || '',
        },
        options: {},
        pageCount: 1,
        column_list: [],
        grid_list: [],
        cityShowsId: 0,
        cityDropdown: false,
        defaultCity: false,
        loading: true,
        timer: null,
        resultList: [],
        state: {
          disabledDates: {
            to: new Date(now - 24*60*60*1000)
          }
        },
        currency_code: localStorage.getItem('currency_code'),
        roomCount: query.room_count || this.$store.getters.getRooms,
        conditions: null,
        domain: domain,
        currentLang: localStorage.getItem('lan_type'),
        BCCConfig: null,
        checkList:[]
      };
    },
    filters:{
      total_tax_price: function (price, tax_fee) {
        var total_price = '';
        total_price = price ? (tax_fee ? (Number(price) + Number(tax_fee)) : Number(price)): '';

        return total_price;
      }
    },
    watch: {
      'params.sort_by': watchParams(),
      // 'params.room_category': watchParams(),
      'params.options': watchParams(),
      'params.page': watchParams(),
      'params.date_from': {
        handler(n, o){
          console.log(n);
          this.params.date_from = formatDateWithStamp(n, true);
          this.params.date_to = dateCompare(n, this.params.date_to);
        }
      },
      'params.date_to': {
        handler(cur, old){
          this.params.date_to = formatDateWithStamp(cur, true);
        }
      },
      options: {
        deep: true,
        handler (n, o){
          let opStr = '';
          for( let key in n){
            if(n[key]){
              opStr += `${n[key]},`;
            }
          }
          this.params.options = opStr;
        }
      },
      checkList:{
        immediate:true,
        handler(newValue){
          this.params.options = newValue.join(',')
        }
      }
    },
    computed: {
      disabledDatesTo () {
        return {
          to: new Date(new Date(this.params.date_from).getTime() + 24*60*60*1000)
        }
      },

      roomCountOptions(){
        const roomCountOptions = [];

        for(let i = 1; i <= 10; i++){
          const hash = {show_txt: i, value: i};

          roomCountOptions.push(hash);
        }

        return roomCountOptions;
      },

      // 当前语言类型
      currentLangType(){
        return +window.localStorage.getItem('lan_type');
      },
    },
    created() {
      let lan_type = returnType(localStorage.getItem('lan_type'));
      this.current_lan = this.$data[lan_type];

      this.$http.getHotelFilterConditions()
        .then((res) => {
          this.filterData = res.data;
          // this.room_category = res.data.room_category;
          this.max_price = res.data.max_price;
          this.fixation_price = res.data.max_price;
          this.params.price_to = res.data.max_price;
        });
      this.$http.getBCCConfig()
        .then((res) => {
          this.BCCConfig = res.data.bcc;
        });
      this.getHotelList();
      this.hotCity();
    },
    mounted() {
      let that = this;
      document.addEventListener("click",function(e){
        e.stopPropagation();
        let target  = e.target;
        if(!target.closest("#city_dropdown, #hotel_dropdown, #search_ipt")){
          that.cityDropdown = false;
          that.defaultCity = false;
        }
      });

      transformSVGA('#courseListSvga', '/static/svga/over_mapping.svga')
    },
    components: {
      VuejsDatepicker,
      RecommendStart,
      BingMap,
      RangeSlide,
      Paginate,
      BgSelect,
      CheckInNumber,
      DoubleDatepicker,
      CheckInRoomNumber,
      MapBox,
      ScrollToTop,
      BaiduMap
    },
    methods: {
      customFormatter(date) {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a');
      },
      clickCallback (res) {
        this.params.page = res
      },

      getHotelList () {
        this.saveRoomConditions();
        // this.$loading.show(this.$i18n.t('hotel.LOADING'));
        this.loading = true;
        this.$http.getHotelList(this.params, this.fixation_price)
          .then((res) => {
            // this.$loading.hide();
            this.loading = false;
            this.hotel_total = res.data.total;
            this.hotel_list = res.data.hotel;
            this.pageCount = Math.ceil(res.data.total / 20);
            this.cityDropdown = false;
            this.defaultCity = false;
            scroll2Top();
          });
      },

      replaceUrl () {
        /*if(this.params.hotel_id == '' && this.resultList.length){
          let resultType = this.resultList[0].place_type;
          if(resultType == 'hotel'){
            this.params.hotel_id = this.resultList[0].place_id;
            this.params.region_id = '';
          }else{
            this.params.hotel_id = '';
            this.params.region_id = this.resultList[0].place_id;
          }
          this.region_name = this.resultList[0].place_name;
        }*/

        this.$router.replace({path: `/list?region_id=${this.params.region_id}&region_name=${this.region_name}&hotel_id=${this.params.hotel_id}&date_from=${this.utilFormatDate(this.params.date_from)}&date_to=${this.utilFormatDate(this.params.date_to)}&lan_type=${this.$route.query.lan_type}`});
        this.params.page = '1'
        this.pageCount = 1
        this.getHotelList();
      },

      // onLink2Detail(hotelId){
      //   this.$router.push({path: `/detail/${hotelId}/${utilFormatDate(this.params.date_from)}/${utilFormatDate(this.params.date_to)}`})
      // },

      utilFormatDate (date) {
        return formatDateWithStamp(date, true);
      },
      getLeft (persent){
        this.params.price_from = Math.ceil(this.fixation_price * persent);
        this.getHotelList();
      },
      getRight (persent){
        if(persent < 0){
          this.params.price_to = this.fixation_price;
        }else{
          this.params.price_to = Math.ceil(this.fixation_price * persent);
        }
        this.getHotelList();
      },
      getMin (x){
        this.min_price = Math.ceil(this.fixation_price * x);
      },
      getMax (x){
        this.max_price = Math.ceil(this.fixation_price * x);

      },
      hotCity () {
        this.$http.getHotRegion()
          .then((res) => {
            this.column_list = res.data.column_list;
            this.grid_list = res.data.grid_list;
            this.cityShowsId = res.data.grid_list[0].rs_id;
          })
      },

      /** 选择搜索项 */
      selectCity (city, type){
        if(type){
          if(city.place_type == 'hotel'){
            this.params.region_id = '';
            this.params.place_id = '';
            this.params.hotel_id = city.place_id;
          }else if(city.place_type === 'region'){
            this.params.hotel_id= '';
            this.params.place_id = '';
            this.params.region_id = city.place_id;
          }else if(city.place_type === 'landmark'){
            this.params.hotel_id= '';
            this.params.place_id = city.place_id;
            this.params.region_id = '';
          }
          this.region_name = city.place_name;
        }else{
          this.params.region_id = city.region_id;
          this.region_name = city.name;
          this.params.hotel_id= '';
          this.resultList = [];
        }
        this.cityDropdown = false;
        this.defaultCity = false;
      },

      /** 关键词搜索 */
      keywordSearch () {
        if(this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.$http.searchRegionOrHotel({keyword: this.region_name, is_show_landmark: 1})
            .then((res) => {
              if(res){
                this.resultList = res.data.place;

                if(res.data.place.length > 0){
                  this.defaultCity = false;
                  this.cityDropdown = true;
                }else{
                  this.defaultCity = true;
                  this.cityDropdown = false;
                }
              }
            });
        }, 300)
      },
      radioToggle(e, value, i){
      //  console.log(this.checkList)
      //  return
       if(this.params.options.indexOf(value) !== -1){
          e.target.checked = false;
          this.options[i] = '';
          this.params.options = this.params.options.replace(`${value},`,'')
        }
      },
      roomCategoryToggle(e, value){
        if(this.params.room_category.indexOf(value) !== -1){
          e.target.checked = false;
          this.params.room_category = ''
        }
      },

      /** 获取房间数 */
      getSelectValue(rooms){
        this.roomCount = rooms;
        this.params.room_count = rooms;
        this.params.adults = rooms;
      },

      /** 获取入住人数数据 */
      // onGetRoomCount(options){
      //   this.conditions = options;
      //   this.params.adults = options.adults;
      //   this.params.children = options.ages.join(',');
      // },

      /** 获取入住人数数据 */
      onGetRoomCount(options){
        this.conditions = options;
        this.params.adults = options.adults;
        this.params.children = options.ages.join(',');

        this.roomCount = options.rooms;
        this.params.room_count = options.rooms;
      },

      /** 保存房间数和入住人数 */
      saveRoomConditions(){
        const data = this.conditions;

        this.$store.dispatch('setRooms', this.params.room_count);
        this.$store.dispatch('setAdults', this.params.adults);

        if(data){
          this.$store.dispatch('setChildren', data.children);
          this.$store.dispatch('setAges', data.ages);
        }else {
          if (this.params.children != null && this.params.children != '') {
            this.$store.dispatch('setChildren', this.params.children.split(',').length);
            this.$store.dispatch('setAges', this.params.children.split(','));
          }else {
            this.$store.dispatch('setChildren', 0);
            this.$store.dispatch('setAges', []);
          }
        }
      },

      /** 跳转到酒店详情页 **/
      onlinkToDetail(obj) {
        var hotel_id = obj.hotel_id;
        var url =  '/detail/'+ hotel_id +'/'+ this.utilFormatDate(this.params.date_from) + '/' + this.utilFormatDate(this.params.date_to);
        this.$router.push(url);
      },

      /** 赋值返回的开始日期跟结束日期 **/
      selectDate(begin, end) {
        this.params.date_from = begin.join('-');
        // console.log(formatDateWithStamp(this.params.date_from, true))
        this.params.date_to = end.join('-');
      },
    },
  }
</script>
<style lang="scss" scoped>
  @import '../../../static/css/common';
  @import './style.scss';
</style>
<style lang="scss">
  .search-bar-x{
    .double-date-box{
      .double-calendar-wrapper{
        height: 70px!important;
        width: 328px!important;
        .servial-night{
          display: none!important;
        }
        .divsion-calendar{
          padding: 0 10px!important;
        }
        .icon-calendar{
          width: 48px!important;
        }
      }
    }
    .slt-wrp{
      width: 233px!important;
      .slt-tar{
        height: 70px!important;
        &:before{
          width: 34px!important;
        }
        .icon-peoples{
          width: 48px!important;
        }
      }
    }
  }

  .chat-bubble {
		position: relative;
		display: inline-block;
		background-color: rgb(0, 151, 255);
		border-radius: 10px;
		padding: 2px;
		margin-bottom: 10px;
		color: #fff;
	}
   .chat-bubble-white{
		position: relative;
		display: inline-block;
		color: #3498db;
		padding: 2px;
		background-color: white;
		border: 1px solid #3498db;
		border-radius: 10px;
	}
    .chat-bubble-white::after {
	    content: '';
	    position: absolute;
	    bottom: -7px;
	    left: 50%;
	    width: 10px;
	    height: 10px;
	    background-color: white;
	    border-right: 1px solid #3498db;
	    border-bottom: 1px solid #3498db;
	    transform: translateX(-50%) rotate(45deg);
	}
    .chat-bubble::after {
		content: "";
		position: absolute;
		bottom: -5px;
		left: 50%;
		transform: translateX(-50%) rotate(45deg);
		width: 10px;
        height: 10px;
		background-color:  rgb(0, 151, 255) ;
	}
    .chat-name{
		display: -webkit-box;
		-webkit-line-clamp:1;
		-webkit-box-orient: vertical;
		text-overflow: ellipsis;
		overflow: hidden;
		word-wrap: break-word;
		word-break: normal;
    position: relative;
    z-index: inherit;
	}

</style>



// WEBPACK FOOTER //
// src/views/hotel_list/HotelList.vue